/* eslint-disable react/prop-types */
import React from "react";
import {
  Box,
  makeStyles,
  useMediaQuery,
  Typography,
  withStyles,
} from "@material-ui/core";
import _ from "lodash";

const useStyles = makeStyles(() => ({
  root: {
    // width: "400px",
    flexWrap: "wrap",
    display: "flex",
    flexDirection: "row",
    padding: "5px 5px 5px 5px",
    marginTop: "5px",
    overflowY: "auto",
    borderRadius: "3px",
    // borderBottom: "1px solid #e2e2e2",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#ECEFF1",
    },
  },
  rootSmall: {
    width: "250px",
    flexWrap: "wrap",
    display: "flex",
    maxHeight: "inherit",
    overflowY: "auto",
    padding: "4px 4px 4px 4px",
    borderRadius: "3px",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#ECEFF1",
    },
  },
}));

const RecommendationFilterComponent = ({
  filterData,
  setSelectedFilter,
  recommendationFilterId,
  setIsBackgroundColorSelected,
  isbackgroundColorSelected,
}) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const classes = useStyles();
  const StyledTypography = withStyles(() => ({
    root: {
      paddingLeft: isSmallScreen ? "0px" : "8px",
      paddingRight: "2px",
      color: "#9e9e9e",
      fontSize: "14px",
    },
  }))(Typography);

  const StyledTypographyContent = withStyles(() => ({
    root: {
      paddingRight: "2px",
      paddingLeft: "2px",
      color: "#9e9e9e",
    },
  }))(Typography);

  const differentFilters = [
    { id: "product", label: "Product" },
    { id: "retailer", label: "Retailer" },
    { id: "line", label: "Line" },
    { id: "category", label: "Category" },
    { id: "area", label: "Area" },
  ];

  const handleSelectedFilter = () => {
    const indexSelected = {};
    indexSelected[recommendationFilterId] = true;
    setIsBackgroundColorSelected(indexSelected);
    setSelectedFilter(filterData);
  };

  return (
    <Box
      style={{
        backgroundColor:
          isbackgroundColorSelected[recommendationFilterId] && "#E86861",
      }}
      className={isSmallScreen ? classes.rootSmall : classes.root}
      onClick={() => handleSelectedFilter()}
      key={recommendationFilterId}
    >
      {_.map(differentFilters, (filter, index) => {
        return filterData[`${filter.id}_label`] !== null &&
          filterData[`${filter.id}id`] !== null ? (
          <div key={index}>
            <StyledTypography
              variant="caption"
              style={{ fontWeight: "bold", color: "black" }}
            >
              {filter.label}:
            </StyledTypography>
            <StyledTypographyContent
              variant="caption"
              style={{
                color: isbackgroundColorSelected[recommendationFilterId]
                  ? "white"
                  : "#9e9e9e",
              }}
            >
              {filterData[`${filter.id}_label`]}
            </StyledTypographyContent>
          </div>
        ) : (
          ""
        );
      })}
    </Box>
  );
};

export default RecommendationFilterComponent;
